export default {
    fy:[
        { value: '2021-2022' },
        { value: '2022-2023' },
        { value: '2023-2024' },
        { value: '2024-2025' },
        { value: '2025-2026' },
        { value: '2026-2027' },
        { value: '2027-2028' },
        { value: '2028-2029' },
        { value: '2029-2030' },
        { value: '2030-2031' },
    ],
}